import React, {useContext, useEffect} from "react"
import {FormattedMessage} from "react-intl";
import Modal from "@amzn/meridian/modal";
import Alert from "@amzn/meridian/alert";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Select from "@amzn/meridian/select";
import SelectOption from "@amzn/meridian/select/select-option";
import Heading from "@amzn/meridian/heading";
import {InductProcessContext} from "./context/InductProcessContext";
import ErrorPage from "../error/ErrorPage";
import LoaderView from "../loader/Loader";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";


const InductProcessDetail = () => {
    const {viewModel, dispatch} = useContext(InductProcessContext)
    const {isMobile} = useDeviceLayout();

    const getDataForInductProcess = () => {
        dispatch({type: 'FETCH_INDUCT_PROCESS_DATA', payload:{dispatcher: dispatch}});
    }

    const resetNodeInductProcessDetailsModalState = () => {
        dispatch({type: 'SET_INDUCT_PROCESS_DETAILS_MODAL_STATE'});
    }

    const selectCycle = (selectedCycle) => {
        dispatch({type: 'CYCLE_SELECTION', selectedCycle: selectedCycle});
    }

    const forceInductChange = (forceInduct) => {
        dispatch({type: 'TOGGLE_FORCE_INDUCT_CHANGE', forceInduct: forceInduct});
    }

    const setInductProcessData = (nodeInductProcessDetails) => {
        const nodeInductProcessDetailsRequest = {
            ...nodeInductProcessDetails,
            state: "STARTED",
            currentCycleDetails: {
                ...nodeInductProcessDetails.currentCycleDetails,
                cycleState: "INDUCT_STARTED"
            }
        }
        dispatch({type: 'SET_INDUCT_PROCESS_DATA', payload:{nodeInductProcessDetailsRequest: nodeInductProcessDetailsRequest, callDispatcher: dispatch}});
    }

    useEffect(() => {
        getDataForInductProcess()
    },[])

    if (viewModel.message) {
        return <ErrorPage error=
            {viewModel.message.includes("induct_management")
            ? viewModel.message
            : "generic.error"} />
    }

    if (viewModel.loading) {
        return (
            <div className="InductManagement">
                <LoaderView />
            </div>
        );
    }

    return (

        <div className="InductManagement">
            <Modal
                type="dialog"
                id="modal-setNodeInductProcessDetailsModalSuccess"
                closeLabel="Close"
                open={viewModel.setNodeInductProcessDetailsModalState}
                describedBy="modal-setNodeInductProcessDetailsModalSuccess_desc"
            >
                <div id="setNodeInductProcessDetailsModalSuccess-modal_desc">
                    <Alert
                        type="success"
                        size="xlarge"
                    >
                        <FormattedMessage id="induct_management.set_node_induct_process_details_success"
                                          defaultMessage="Induct Cycle has been started successfully">
                        </FormattedMessage>
                    </Alert>
                </div>
                <Row alignmentHorizontal="right" widths="fit">

                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            resetNodeInductProcessDetailsModalState()
                        }}
                    >
                        <FormattedMessage id="generic.close" defaultMessage="Close">
                        </FormattedMessage>
                    </Button>
                </Row>
            </Modal>
            <Row
                widths={isMobile ? ["grid-8", "grid-4"] : ["grid-9", "grid-3"]}
                wrap="down"
                alignment="center right"
                spacingInset={isMobile ? "none" : "large"}
            >
                <Box
                    type="outline"
                    spacingInset="medium"
                    minHeight={400}
                >
                    <Row
                        widths={"fill"}
                        wrap="down"
                        alignment="center right"
                        spacingInset="medium"
                    >
                        <Heading level={4}>
                            <FormattedMessage id="induct_management.induct_setup" defaultMessage="Induct Setup">
                            </FormattedMessage>
                        </Heading>
                    </Row>
                    <Row
                        widths={"fill"}
                        wrap="down"
                        alignment="center left"
                        spacingInset="medium"
                    >
                        <Column
                            heights={"fill"}
                            alignment="top left"
                        >
                            {typeof viewModel.items.cycleDetailsList === 'undefined' || viewModel.items.cycleDetailsList.length === 0 ?
                                <Box>
                                    <Alert
                                        type="warning"
                                        size="medium"
                                    >
                                        <Text>
                                            <FormattedMessage
                                                id="induct_management.no_active_container_plans_available"
                                                defaultMessage="There are no active container plans configured for this station, Please try again later">
                                            </FormattedMessage>
                                        </Text>
                                    </Alert>
                                </Box>
                                : null}

                            <Box>
                                <Text>
                                    <FormattedMessage id="induct_management.select_cycle"
                                                      defaultMessage="Select Cycle">
                                    </FormattedMessage>
                                </Text>
                            </Box>
                            <Box>
                                <Row
                                    widths={"fill"}
                                    wrap="down"
                                    alignment="center left"
                                >
                                    <Box minWidth={200}>
                                        <Select
                                            value={viewModel.items.nodeInductProcessDetails.currentCycleDetails &&
                                            (viewModel.items.nodeInductProcessDetails.currentCycleDetails.cycleState === "PICK_STARTED" ?
                                                "" : viewModel.items.nodeInductProcessDetails.currentCycleDetails.cycleName)}
                                            onChange={(selectedCycle) => {
                                                selectCycle(selectedCycle)
                                            }}
                                            size="small"
                                        >
                                            {viewModel.items.cycleDetailsList.map(cycle => (
                                                <SelectOption key={cycle.cycleID}
                                                              value={cycle.cycleName ? cycle.cycleName : ""}
                                                              label={cycle.cycleName ? cycle.cycleName : ""}/>
                                            ))}
                                        </Select>
                                    </Box>
                                    <Box>
                                        <Text>
                                            <FormattedMessage id="induct_management.current_sort_cycle"
                                                              defaultMessage="Current Sort Cycle">
                                            </FormattedMessage> : {viewModel.lastCycle ? viewModel.lastCycle.cycleName : ""}
                                            {(viewModel.lastCycle && viewModel.lastCycle.cycleState && viewModel.lastCycle.cycleState === "PICK_STARTED") ?
                                                <Text>
                                                    <FormattedMessage id="induct_management.current_cycle_state"
                                                                      defaultMessage="Current Cycle State">
                                                    </FormattedMessage> : {viewModel.lastCycle.cycleState}
                                                </Text>
                                                : ""}
                                        </Text>
                                    </Box>
                                </Row>
                            </Box>
                            <Box>
                                <Text>
                                    <FormattedMessage id="induct_management.enable_force_induct"
                                                      defaultMessage="Enable Force Induct">
                                    </FormattedMessage>
                                </Text>
                            </Box>
                            <Box>
                                <Row
                                    widths={"fill"}
                                    wrap="down"
                                    alignment="center left"
                                >
                                    <Box minWidth={200}>
                                        <Select
                                            value={viewModel.items.nodeInductProcessDetails.isForcedInductEnabled ? "true" : "false"}
                                            onChange={(forceInduct) => {
                                                forceInductChange(forceInduct)
                                            }}
                                            size="small"
                                        >
                                            <SelectOption value="true" label="Yes"/>
                                            <SelectOption value="false" label="No"/>
                                        </Select>
                                    </Box>
                                    <Box>
                                        <Text>
                                            <FormattedMessage id="induct_management.current_force_induct_status"
                                                              defaultMessage="Current Force Induct Status">
                                            </FormattedMessage> : <FormattedMessage
                                            id={viewModel.currentForceInductStatus ? "generic.enabled" : "generic.disabled"}
                                            defaultMessage="">
                                        </FormattedMessage>
                                        </Text>
                                    </Box>
                                </Row>
                            </Box>
                        </Column>
                    </Row>
                </Box>
                <Box
                    type="outline"
                    spacingInset={isMobile ? "none" : "medium"}
                    minHeight={400}
                >
                    <Row
                        widths={"fill"}
                        wrap="down"
                        alignment="center left"
                        spacingInset="medium"
                    >
                        <Button
                            type="primary"
                            size ={isMobile ? "small" : "medium"}
                            disabled={viewModel.items.nodeInductProcessDetails.currentCycleDetails &&
                                ((Object.keys(viewModel.items.nodeInductProcessDetails.currentCycleDetails).length === 0 &&
                                viewModel.items.nodeInductProcessDetails.currentCycleDetails.constructor === Object) ||
                                viewModel.items.nodeInductProcessDetails.currentCycleDetails.cycleState === "PICK_STARTED")}
                            onClick={() => {
                                setInductProcessData(viewModel.items.nodeInductProcessDetails)
                            }}
                        >
                            <FormattedMessage id="induct_management.start_sort_cycle" defaultMessage="Start Induct">
                            </FormattedMessage>
                        </Button>
                    </Row>
                </Box>
            </Row>
        </div>
    );
}

export default InductProcessDetail


// WEBPACK FOOTER //
// ./src/components/inductManagement/InductProcessDetail.js